/* 
Author:Lamiaa Moustafa
Desc: Timestamp component
*/

import { React, useState, useEffect } from "react";
import styled from "styled-components";
import Dropdown1st2911 from "../../../../components/dropdown1st2911";
import TextS1st2911 from "../../../../components/text/TextS1st2911";
import { selectStyle } from "../../../../Styles/styledComponents/ReactSelect"

const TimeStamp = ({ setSelectedTimeStamp }) => {
  const options = [
    { id: 0, label: "Last 15 Minutes", value: "Last15minutes" },
    { id: 1, label: "Past 24 Hours", value: "Past24hours" },
  ];
  const [selectValue, setSelectValue] = useState(options[0]);
  const [timeframe, setTimeFrame] = useState("");
  const date = new Date();
  //console.log(date)
  const currentTime = date.toLocaleString();
  const past15minutes = new Date(
    date.getTime() - 15 * 60 * 1000
  ).toLocaleString();
  const past24hours = new Date(
    date.getTime() - 24 * 60 * 60 * 1000
  ).toLocaleString();
  const currentTimeMilliSecs = Math.round(date.getTime());
  const last24hoursMilliSecs = Math.round(
    new Date(date.getTime() - 24 * 60 * 60 * 1000).getTime()
  );
  const last15minsMilliSecs = Math.round(
    new Date(date.getTime() - 15 * 60 * 1000).getTime()
  );
   //On page load, show past 15 minutes timestamp
//    useEffect(() => {
//     setSelectValue(options[0]);
//     setTimeFrame(`${past15minutes} to ${currentTime}`);
//     setSelectedTimeStamp({
//       currentTime: currentTimeMilliSecs,
//       previousTime: last15minsMilliSecs,
//     });
//   }, []);

  // When timestamp is selected by user, show the timeframe based on user selection
  const handleChangeTimeStamp = (selected) => {
    // console.log(selected);
    // console.log(selected.value);
    setSelectValue(selected);
    if (selected.value === "Last15minutes") {
      setTimeFrame(`${past15minutes} to ${currentTime}`);
      setSelectedTimeStamp({
        currentTime: currentTimeMilliSecs,
        previousTime: last15minsMilliSecs,
      });
    } else if (selected.value === "Past24hours") {
      setTimeFrame(`${past24hours} to ${currentTime}`);
      setSelectedTimeStamp({
        currentTime: currentTimeMilliSecs,
        previousTime: last24hoursMilliSecs,
      });
    }
  };

  return (
    <TimeStampDiv>
      <Dropdown1st2911 data={{ placeholder: "Select...", options: options, value:selectValue, customStyle: selectStyle,onchange:handleChangeTimeStamp,defaultValue:options[0] }} />
      <TextS1st2911 data={{ text:timeframe}} />
      <TextS1st2911 data={{ text: "Total Incidents:" }} />
    </TimeStampDiv>
  );
};

export default TimeStamp;

const TimeStampDiv = styled.div`
  width: 100%;
  height:25vh;
  border-bottom:1px solid var(--darkGray);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 10px;
  p {
    margin-top: 10px;
  }
`;
